import { z } from "zod";

export const stopSectionSchema = z.object({
	facilityName: z.string().nullable(),
	address1: z.string().nullable(),
	address2: z.string().nullable(),
	city: z.string().nullable(),
	state: z.string().nullable(),
	postalCode: z.string().nullable(),
	country: z.string().nullable(),
	contactName: z.string().nullable(),
	contactPhone: z.string().nullable(),
	phoneExtension: z.string().nullable(),
	appointmentStartTime: z.string().nullable(),
	appointmentEndTime: z.string().nullable(),
	scheduledDate: z.string().nullable(),
	actualTimestamp: z.string().nullable(),
	referenceNumber: z.string().nullable(),
	remarks: z.string().nullable(),
	accessorials: z.array(z.string()),
	appointmentNotes: z.string().nullable(),
	hoursOfOperation: z.string().nullable(),
	stopType: z.enum(["Pickup", "Delivery"]),
	sequence: z.number().int().positive(),
	timeType: z.enum(["Unknown", "Fcfs", "Appointment"]),
});

export const shipmentStopDetailsSchema = z.object({
	pickups: z.array(stopSectionSchema),
	deliveries: z.array(stopSectionSchema),
});

export type StopSection = z.infer<typeof stopSectionSchema>;
export type ShipmentStopDetails = z.infer<typeof shipmentStopDetailsSchema>;
